import ConfigLoader from "../../config/configLoader";
import {WidgetConfig} from "../../types/config";
import {AgentMessageObject, BotMessageObject, Response} from "../../types/chat";
import JsonComponent from "../response/jsonComponent";
import BotChat from "../botChat";
import {MessageFactory} from "../factory/messageFactory";
import ChatHelper from "./chatHelper";
import ComponentConfig from "../../config/componentConfig";
import {ChatType} from "../../types/enums";
import UserData from "../user/UserData";

const config = await ConfigLoader.getConfig();

export class ChatApi {

    private readonly widgetConfig: WidgetConfig;
    private activeChat: null|BotChat = null;
    private readonly componentConfig: ComponentConfig;
    private readonly agentChatAvailableElement: HTMLElement|null;
    private readonly noAgentChatAvailableElement: HTMLElement|null;
    private chatHelper: null|ChatHelper = null;

    constructor(
        private readonly callback: (answer: Response) => void,
        apiConfig: object,
        agentChatAvailable: HTMLElement|null,
        noAgentChatAvailable: HTMLElement|null,
    ) {
        this.widgetConfig = config;
        this.componentConfig = new ComponentConfig();
        this.componentConfig.setConfig(apiConfig);
        this.agentChatAvailableElement = agentChatAvailable;
        this.noAgentChatAvailableElement = noAgentChatAvailable;
    }

    public async sendBotChatMessage( message: string ): Promise<void>
    {
        message = message.trim();
        if(message === "") {
            return;
        }

        let chat = await this.getActiveChat();
        let messageObject = this.getMessageObject(ChatType.BOT_CHAT, message);

        await chat.sendMessage(messageObject);
    }

    public async initAgentAvailabilityCheck(): Promise<void>
    {
        if(this.agentChatAvailableElement !== null) {
            await this.getChatHelper().initAgentAvailabilityCheck();
        }
    }

    public stopAgentAvailabilityCheck(): void
    {
        this.getChatHelper().setAgentAvailabilityCheckToEnd();
    }

    private async getActiveChat():Promise<BotChat>
    {
        if (this.activeChat === null) {
            let contentHandler = new JsonComponent(this.callback);
            this.activeChat = new BotChat(this.widgetConfig, this.componentConfig, contentHandler);
            await this.activeChat.initConnection();
        }

        return this.activeChat;
    }

    private getMessageObject(chatType: string, message: string): BotMessageObject | AgentMessageObject {
        return MessageFactory.create(chatType, message, this.widgetConfig.trademark);
    }

    private getChatHelper(): ChatHelper
    {
        if(this.chatHelper instanceof ChatHelper) {
            return this.chatHelper;
        }

        let chatHelper = new ChatHelper(
            this.widgetConfig,
            this.componentConfig,
            this.agentChatAvailableElement,
            this.noAgentChatAvailableElement
        );
        this.chatHelper = chatHelper;
        return chatHelper;
    }
}